import { Fragment } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@ingrid/luterkort-react';

import { DetailsDrawer as Drawer } from '~src/components/DetailsDrawer/DetailsDrawer';
import { RoleGuard } from '~src/components/RoleGuard/RoleGuard';
import { useTranslation } from '~src/i18n/use-translation';
import { useSiteId } from '~src/main/hooks/useSiteId';
import { AppRoute } from '~src/main/routes';

import { PendingShipmentListItem } from '../queries';

interface Props {
  pendingShipment?: PendingShipmentListItem;
}

function PendingShipmentDrawerAction({ pendingShipment }: Props) {
  const siteId = useSiteId();
  const { t } = useTranslation();

  return (
    <Fragment>
      <RoleGuard roles={['transport:edit']} withTooltip>
        <Button
          to={`/${AppRoute.SITE}/${siteId}/${AppRoute.SHIPMENTS}/${AppRoute.CREATE}/${AppRoute.PENDING}/${pendingShipment?.lookup_id}`}
          as={Link}
        >
          {t('common.createShipment')}
        </Button>
      </RoleGuard>
    </Fragment>
  );
}

export function DetailsDrawer({ pendingShipment }: Props) {
  const { t } = useTranslation();

  return (
    <Drawer
      actions={<PendingShipmentDrawerAction pendingShipment={pendingShipment} />}
      nodes={[
        <Drawer.Banner
          subtitle={pendingShipment?.raw_error_message}
          when={!!pendingShipment?.raw_error_message}
          title={t('errors.generic')}
          variant="critical"
          key="error"
        />,
        <Drawer.Plain label={'common.pendingShipmentId'} value={pendingShipment?.lookup_id} key="lookup-id" />,
        <Drawer.Plain label={'common.externalId'} value={pendingShipment?.payload.external_id} key="external-id" />,
        <Drawer.Plain label="common.orderId" value={pendingShipment?.payload.tos_id} key="tos-id" />,
        <Drawer.CarrierProduct
          label="common.carrierProduct"
          value={pendingShipment?.payload.shipping_method}
          key="carrier"
        />,
        <Drawer.Address label="common.shipFrom" value={pendingShipment?.payload.address_from} key="from" />,
        <Drawer.Address label="common.shipTo" value={pendingShipment?.payload.address_to} key="to" />,
        <Drawer.Date label="common.createdAt" value={pendingShipment?.created_at} time key="created" />,
        <Drawer.Date label="common.expiresAt" value={pendingShipment?.expires_at} time key="expires" />,
      ]}
    />
  );
}
